<template>
  <section id="faq" class="faq">
    <div class="shell faq-grid">
      <header v-reveal class="faq-head">
        <h2>Frequently asked questions</h2>
        <p>
          Can’t find what you’re looking for?
          <a href="#contact" class="text-link">Ask me directly</a>
        </p>
      </header>
      <div v-reveal class="faq-list">
        <details v-for="item in items" :key="item.q" class="faq-item">
          <summary>
            {{ item.q }}<span class="faq-toggle" aria-hidden="true"></span>
          </summary>
          <p>{{ item.a }}</p>
        </details>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "FaqSection",
  data: () => ({
    items: [
      {
        q: "What kinds of projects do you take on?",
        a: "Backend systems, APIs and integrations, workflow automation, full-stack web applications, mobile apps, and cloud and data work. Projects range from automating one repetitive task to building a complete customer portal.",
      },
      {
        q: "Do you work with businesses outside Jamaica?",
        a: "Yes. I work remotely with clients wherever they are, with calls, shared progress and demos along the way.",
      },
      {
        q: "How much does a project cost?",
        a: "It depends on the scope. After we talk through what you need, you get a clear plan with the scope, price and timeline, agreed before any work begins.",
      },
      {
        q: "How long does a project take?",
        a: "You get a timeline as part of the plan, before the build starts. Smaller automations and integrations are usually much quicker than full applications, and you see working progress early either way.",
      },
      {
        q: "Can you work with the systems we already use?",
        a: "Yes. Much of my work is connecting existing software: payment processors, CRMs, databases and file-based systems, over REST, SOAP or SFTP. We keep what works and improve what doesn’t.",
      },
      {
        q: "Do you offer support after launch?",
        a: "Yes. I walk you through everything at launch, and we agree on the support you need next, from occasional fixes to ongoing improvements.",
      },
      {
        q: "How do we get started?",
        a: "Send me a message on WhatsApp, or email or call if you prefer, and tell me what you’re working on. I’ll read it myself and let you know how I can help.",
      },
    ],
  }),
};
</script>
